import { render } from "./Haccp.vue?vue&type=template&id=2fed3d1e"
import script from "./Haccp.vue?vue&type=script&lang=js"
export * from "./Haccp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__